import { useContext } from 'react';
import { AppContext } from '../AppContext';

function useIsLoggedIn() {
    const { userId } = useContext(AppContext);
    return Boolean(userId);
}

export default useIsLoggedIn;